import { render, staticRenderFns } from "./PartnershipCardLink.vue?vue&type=template&id=6f3e127b&scoped=true&"
import script from "./PartnershipCardLink.vue?vue&type=script&lang=js&"
export * from "./PartnershipCardLink.vue?vue&type=script&lang=js&"
import style0 from "./PartnershipCardLink.vue?vue&type=style&index=0&id=6f3e127b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3e127b",
  null
  
)

export default component.exports